import React from 'react';

import Repos from './Repos';

export default () => (
  <div>
    <p>
      Converted a non-responsive landing page into responsive design.
      Front-end only using
      {' '}<a href="https://facebook.github.io/react/">React</a> and
      {' '}<a href="http://react.semantic-ui.com/introduction">Semantic UI</a>
    </p>

    <p>
      <Repos repos={[{
        href: 'https://github.com/michael-software-engr/map_my_meetups',
        text: 'michael-software-engr/map_my_meetups'
      }]} />
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/ConversionToResponsiveDesign.js